import { createApi } from '@reduxjs/toolkit/query/react'
import { Organization } from './models'
import { getBaseQuery } from './baseQuery'

// CONTRUCT ENDPOINTS AND API CALL HOOKS
export const organizationAPI = createApi({
  reducerPath: 'organizationAPI',
  baseQuery: getBaseQuery('Organization'),
  tagTypes: ['org'],
  endpoints: builder => ({
    GetOrganization: builder.query<Organization, void>({
      query: () => 'GetOrganization',
      providesTags: ['org'],
    }),
    ToggleUse2FA: builder.mutation<void, { assetCompanyID: number }>({
      query: ({ assetCompanyID }) => ({
        url: 'ToggleUse2FA',
        method: 'POST',
        body: { assetCompanyID },
      }),
      invalidatesTags: ['org'],
    }),
  }),
})

// Export the auto-generated hooks from the endpoints constructed in createApi
export const { useGetOrganizationQuery, useToggleUse2FAMutation } = organizationAPI
